/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit UsePatientValue/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function UsePatientValue({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/Content/ContactInput/UsePatientValue",
  strokeSelected,
  backgroundColorSelected,
  borderColorSelected,
  borderColorHovered
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let questionIdValueData = fromData.useDataValue({ viewPath,
context: 'question',
path: 'id',
})
let constantData = 'responsiblePersonContactDetails'
let aggregateData = fromAggregate.equals(questionIdValueData, constantData)
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(aggregateData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
 strokeSelected={strokeSelected}
 backgroundColorSelected={backgroundColorSelected}
 borderColorSelected={borderColorSelected}
 borderColorHovered={borderColorHovered}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}